// Entscheidung nach einem 401: abmelden oder nicht?
// Eine Anfrage, die noch mit einem ALTEN Token lief (anderer Tab, eigener Passwortwechsel),
// darf niemanden abmelden, wenn im Speicher schon ein neues Token liegt.
export const NACHPRUEFEN_MS = 300;
// Token aus dem Authorization-Header einer axios-Anfrage (AxiosHeaders oder einfaches Objekt).
export function tokenAusHeader(headers) {
  if (!headers) return null;
  const wert = typeof headers.get === 'function'
    ? headers.get('Authorization')
    : (headers.Authorization ?? headers.authorization);
  const text = String(wert || '');
  return text.startsWith('Bearer ') ? text.slice(7) : null;
}
// 'abmelden' | 'behalten' | 'nachpruefen'
export function abmeldeEntscheidung(anfrageToken, gespeichertesToken) {
  if (!gespeichertesToken) return 'abmelden';
  if (anfrageToken !== gespeichertesToken) return 'behalten';
  return 'nachpruefen';
}
// Gleiches Token wie im Speicher: kurz warten, ob gerade ein neues ankommt.
export async function sollAbmelden(anfrageToken, liesToken, warten) {
  const erste = abmeldeEntscheidung(anfrageToken, liesToken());
  if (erste !== 'nachpruefen') return erste === 'abmelden';
  await warten(NACHPRUEFEN_MS);
  return abmeldeEntscheidung(anfrageToken, liesToken()) !== 'behalten';
}
